const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg", "mov", "avi"];
const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp"];
const PRESENTATION_EXTENSIONS = ["ppt", "pptx", "pps", "ppsx"];

interface PreviewKindInput {
  mime?: string;
  originalExtension?: string;
  previewExtension?: string;
  previewMime?: string;
}

export function formatBytes(size: number | string | null | undefined): string {
  if (!size) {
    return "0 B";
  }

  const units = ["B", "KB", "MB", "GB"];
  let value = Number(size);
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value >= 10 ? Math.round(value) : value.toFixed(1)} ${units[unitIndex]}`;
}

export function getFileExtension(fileName = ""): string {
  if (!fileName || fileName.indexOf(".") === -1) {
    return "";
  }

  return fileName.split(".").pop()?.toLowerCase() || "";
}

export function getFileKind(fileNameOrExtension = ""): string {
  const normalizedValue = String(fileNameOrExtension || "").toLowerCase();
  const extension =
    normalizedValue.indexOf(".") !== -1 ? getFileExtension(normalizedValue) : normalizedValue;

  if (extension === "pdf") {
    return "pdf";
  }

  if (IMAGE_EXTENSIONS.includes(extension)) {
    return "image";
  }

  if (VIDEO_EXTENSIONS.includes(extension)) {
    return "video";
  }

  if (PRESENTATION_EXTENSIONS.includes(extension)) {
    return "presentation";
  }

  return "file";
}

export function getFileKindFromMime(mime = ""): string {
  const normalizedMime = String(mime || "").toLowerCase();

  if (normalizedMime === "application/pdf") {
    return "pdf";
  }

  if (normalizedMime.startsWith("image/")) {
    return "image";
  }

  if (normalizedMime.startsWith("video/")) {
    return "video";
  }

  if (
    normalizedMime.includes("powerpoint") ||
    normalizedMime.includes("presentationml") ||
    normalizedMime.includes("slideshow")
  ) {
    return "presentation";
  }

  return "file";
}

export function getPreviewKind({
  mime = "",
  originalExtension = "",
  previewExtension = "",
  previewMime = "",
}: PreviewKindInput): string {
  const originalKindFromExtension = getFileKind(originalExtension);
  const originalKind =
    originalKindFromExtension !== "file" ? originalKindFromExtension : getFileKindFromMime(mime);
  const previewKindFromExtension = getFileKind(previewExtension);
  const previewKind =
    previewKindFromExtension !== "file"
      ? previewKindFromExtension
      : getFileKindFromMime(previewMime);

  if (["file", "presentation"].includes(originalKind) && previewKind !== "file") {
    return previewKind;
  }

  return originalKind;
}
